import React from "react";

type NotificationPanelProps = {
  selectedNotificationDays: string[];
};

const dayAbbreviations: Record<string, string> = {
  Monday: "Mon",
  Tuesday: "Tue",
  Wednesday: "Wed",
  Thursday: "Thu",
  Friday: "Fri",
  Saturday: "Sat",
  Sunday: "Sun",
};

export const NotificationPanel = ({
  selectedNotificationDays,
}: NotificationPanelProps) => {
  return (
    <>
      {selectedNotificationDays.length > 0 ? (
        <div className="select-component__duration-section">
          <div className="strength-button select-component__duration-button">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                width: "100%",
              }}
            >
              {selectedNotificationDays.map((day) => (
                <span
                  key={day}
                  style={{
                    fontWeight: 700,
                    color: "#ffffff",
                    textAlign: "center",
                    backgroundColor: "#2563eb",
                    padding: "6px 10px",
                    borderRadius: "4px",
                  }}
                >
                  {dayAbbreviations[day]}
                </span>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="select-component__duration-section">
          <div className="cause-list__empty">
            <p>No days selected</p>
          </div>
        </div>
      )}
    </>
  );
};
